/**
 * Detail buttons snippet
 *
 * @author Mautilus s.r.o.
 * @class Snippet_DetailButtons
 * @extends Snippet
 */

Snippet_Detail_Buttons = (function(Snippet) {

	var Snippet_Detail_Buttons = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Detail_Buttons.prototype, Snippet.prototype, {

		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(){
			this.items = [{label:__('play'), action: 'playVid'}, {label:__('go_back_catalog'), action: 'go-back'}, {label:__('add_favorites'), action: 'favorites'}];
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			return $('<div id="snippet-detail-buttons" />');
		},

		/**
		 * @inheritdoc Snippet#render
		 */
		render: function(is_favourite) {
			var buttons = '<ul>';
			if(is_favourite){this.items[2].label = __('remove_favorites');}
			for(var i in this.items){
				buttons += this.createButton(this.items[i]);
			}
			buttons += '</ul>';
			this.$el.html(buttons);
		},

		createButton: function(item) {
			var button =
			'<li class="focusable button" data-action="' + item.action + '">' +
			'	<div class="name">' + item.label + '</div>' +
			'</li>';
			return button;
		},

		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction){
			if(direction === 'right'){
				return (! Focus.to(this.getFocusable(1, true)));
			}else if(direction === 'left'){
				return (! Focus.to(this.getFocusable(-1, true)));
			} else if(direction === 'down') {
				this.trigger('focus:out', this, 'down');
			} else if(direction === 'up') {
                this.trigger('focus:out', this, 'up');
            }
			return false;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function ($el) {
			if (this.$lastFocused) {
				return Focus.to(this.$lastFocused);
			}
			if (!$el) {
				$el = this.getFocusable(0);
			}
			return Focus.to($el);
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function ($el) {
			if(this.$lastFocused)
				this.$lastFocused.toggleClass('last-focused');
			this.$lastFocused = $el;
			this.$lastFocused.toggleClass('last-focused');
		},
	});

	return Snippet_Detail_Buttons;

})(Snippet);



//////////////////
// WEBPACK FOOTER
// ./js/snippet/detail_buttons.js
// module id = 62
// module chunks = 0